module.exports = __webpack_public_path__ + "img/SPB.8486123d.png";